import type { StepConfig } from "@portal/components/multiform/types";
import { BondStep } from "../../../../../agent/request/create/steps/bond/BondStep";
import { BondSummary } from "../../../../../agent/request/create/steps/bond/BondSummary";
import type { AdminBondRequestFormData } from "../../schema";

export const bondStepConfig: StepConfig<AdminBondRequestFormData> = {
	name: "bond",
	label: "Bond",
	fieldPaths: ["quote"],
	component: BondStep,
	summaryComponent: BondSummary,
};
